import { takeEvery, call, put } from "redux-saga/effects";
import {
  TRIGGER_REPORTER_RUN_REQUEST,
  TRIGGER_REPORTER_RUN_SUCCESS,
  TRIGGER_REPORTER_RUN_FAILURE,
} from "../actions/reporterAgentActions";
import { triggerReporterRunApi } from "../apis/reporterAgentApi";

function* triggerReporterRunSaga(action) {
  try {
    const result = yield call(triggerReporterRunApi, action.payload);
    yield put({ type: TRIGGER_REPORTER_RUN_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_REPORTER_RUN_FAILURE, error: error.message });
  }
}

export default function* reporterAgentSaga() {
  yield takeEvery(TRIGGER_REPORTER_RUN_REQUEST, triggerReporterRunSaga);
}
